// supabaseFreeTable.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_FREE_TABLE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_FREE_TABLE_KEY;

export const supabaseFreeTable = createClient(supabaseUrl, supabaseKey);